import { ApiResponse } from "../../../types/api.types";
import axiosClient from "../../../utils/axios";

export const getPrivacyPolicy = async () => {
  try {
    const res = await axiosClient.post<
      ApiResponse<any>
    >("/cms/view", {
      label: "privacy_policy",
    });

    return res.data;
  } catch (err) {
    console.warn("Error fetching privacy policy:", err);
    throw err;
  }
};